import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { ExpenseCategory } from './useExpensesQuery';
import { ESTIMATE_EXPENSE_ENDPOINT } from './useEstimateExpensesMutation';

interface EstimateResult {
  Category: ExpenseCategory;
  EstimatedValue: number;
}

interface FetcherParams {
  clientId: string;
  category: ExpenseCategory;
}

const estimateExpenseCategory = ({
  clientId,
  category,
}: FetcherParams): Promise<EstimateResult> => {
  return authFetch(urlWithParams(ESTIMATE_EXPENSE_ENDPOINT, { clientId, category }));
};

export const useEstimateExpenseCategoryMutation = () => {
  return useMutation(estimateExpenseCategory);
};
